import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import type { RcFile } from 'antd/lib/upload';
import { tail } from 'lodash';
import * as XLSX from "xlsx";
import {mixConvertSize} from '../../../services/mixin';
const ALLOWED_FORMATS = ['xls', 'xlsx', 'csv'];
const fileIcon = {
  'csv': '/images/icons/files/csv.svg',
  'doc': '/images/icons/files/doc.svg',
  'xlsx': '/images/icons/files/xls.svg',
  'xls': '/images/icons/files/xls.svg',
  'pdf': '/images/icons/files/pdf.svg',
  'zip': '/images/icons/files/zip.svg',
  'rar': '/images/icons/files/rar.svg',
  'ppt': '/images/icons/files/ppt.svg',
  'jpg': '/images/icons/files/jpg.svg',
  'png': '/images/icons/files/png.svg',
  'img': '/images/icons/files/img.svg',
} as any

const FileUploadManager = ({ importHistory = [] as any, stData = {} as any, onChange = (data = {}, type = null) => { } }) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const excelDateToString = (serial: number): string => {
    // Số serial hợp lệ của Excel thường lớn hơn 25569 (tương ứng 1/1/1970)
    if (typeof serial !== "number" || serial < 25569 || serial > 60000) return serial as unknown as string;
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);
    // Định dạng dd/mm/yyyy
    return date_info.getDate().toString().padStart(2, '0') + '/' +
      (date_info.getMonth() + 1).toString().padStart(2, '0') + '/' +
      date_info.getFullYear();
  };
  function percentExistArr2InArr1(arr1: string[], arr2: string[]): number {
    const existCount = arr2.filter(item2 =>
      arr1.some(item1 => item1.trim().toLowerCase() === item2.trim().toLowerCase())
    ).length;
    return Math.round((existCount / arr2.length) * 10000) / 100;
  }
  const checkFileIsDate = (fileName: string) => {
    const dateFile = ['TimeDelivery', 'EstimatedTimeDelivery']
    const lowerFileName = fileName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return lowerFileName.includes("date") || lowerFileName.includes("ngày") || lowerFileName.includes("intime") || lowerFileName.includes("day") || lowerFileName.includes("monthyear") || lowerFileName.includes("doctime") || lowerFileName.includes("createdat") || dateFile.includes(fileName);
  }
  const checkFiles = async (fileList: any) => {
    // Hàm đọc headers từ file
    const readFile = (file: File): Promise<any[]> => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array', sheetRows: 10 });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0] || [] as any;
          const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[];
          const firstFiveRows = rows.slice(1, 6); // exclude header, get next 5 rows
          // Chuyển firstFiveRows từ mảng sang object với key là header
          const filesParams = {} as any
          filesParams[file.name] = {}
          const paramTrue = [] as any
          headers.map((val: any) => {
            const findData = stData.sourceColumns.find((x: any) => x.json.includes(`"${val}"`))
            filesParams[file.name][val] = findData ? findData.column : null;
            if (findData) {
              paramTrue.push(findData.column);
            } else {
              paramTrue.push(val);
            }
          })
          const firstFiveRowsObj = firstFiveRows.map((row: any) => {
            const obj: any = {};
            headers.forEach((header: string, idx: number) => {
              let value = row[idx];
              if (
                typeof row[idx] === "number" &&
                checkFileIsDate(header)
              ) {
                value = excelDateToString(value);
              }
              obj[header] = value;
            });
            return obj;
          });
          const isSource = {
            name: '',
            percent: 0,
            id: null
          } as any;
          stData.source.map((val: any) => {
            if (!val.nameColumns || val.nameColumns.length === 0) return true;
            const percent = percentExistArr2InArr1(val.nameColumns, paramTrue);
            console.log(percent, 'percent', val.name);
            if (percent > isSource.percent) {
              isSource.name = val.name;
              isSource.id = val.id;
              isSource.percent = percent;
            }
            return true;
          });
          const res = {
            headers,
            firstFiveRows: firstFiveRowsObj,
            isSource,
            filesParams
          } as any
          resolve(res);
        };
        reader.onerror = () => resolve([]);
        reader.readAsArrayBuffer(file);
      });
    };

    // Duyệt qua từng file, trả về mảng Promise kết quả
    const resultPromises = fileList.map(async (file: any) => {
      const tailName = file.name.split('.').pop()?.toLowerCase() || '';
      let error = [];
      const lsEr = [] as any;
      let warnings = '' as any;
      if (!ALLOWED_FORMATS.includes(tailName)) {
        error.push('File không đúng định dạng, vui lòng import file khác.');
      }
      if (importHistory.some((h: any) => h.name === file.name)) {
        error.push('File đã được import trước đó');
      }
      // Đọc headers nếu không có lỗi
      let dataRender = {
        headers: [],
        firstFiveRows: [],
        isSource: { name: '', percent: 0, id: null },
        filesParams: {},
      } as any;
      if (error.length === 0) {
        dataRender = await readFile(file) as any;
        // if (dataRender.isSource.percent < 90) {
        //   error = `Trùng khớp với nguồn ${dataRender.isSource.name} là ${dataRender.isSource.percent}%. (100% mới được chấp nhận)`;
        // }
        if (dataRender.isSource.percent === 0) {
          error.push('Không khớp với bất kỳ nguồn nào.');
        }
        if (dataRender.headers.length === 0) {
          error.push('Không thể đọc được dữ liệu, vui lòng kiểm tra lại file.');
        }
        if (dataRender.firstFiveRows.length === 0) {
          error.push('File không có dữ liệu.');
        }

        const temp1 = {} as any;
        const obTemp = dataRender.filesParams[file.name] as any;
        let missparam = 0
        Object.keys(obTemp).forEach((key) => {
          if (obTemp[key] !== null) {
            if(temp1[obTemp[key]]) {
              lsEr.push({
                val1: temp1[obTemp[key]],
                val2: key,
                pr: stData.obSourceColumns[obTemp[key]].name,
              });
            } else {
              temp1[obTemp[key]] = key;
            }
          } else {
            missparam += 1;
          }
        })
        if (lsEr.length > 0) {
          error.push('Có giá trị bị trùng trong file Excel. Vui lòng kiểm tra lại!');
        }
        // if (missparam > 0) {
        //   warnings = `Có ${missparam} trường dữ liệu không nằm trong template. Vui lòng kiểm tra lại!`;
        // }
      }
      return {
        uid: uuidv4(),
        file,
        headers: dataRender.headers,
        firstFiveRows: dataRender.firstFiveRows,
        name: file.name,
        size: file.size,
        tail: tailName,
        icon: fileIcon[tailName] || '/images/icons/files/unknown.svg',
        status: 1,
        error,
        warnings,
        lsEr,
        isSource: dataRender.isSource.name,
        isSourceId: dataRender.isSource.id,
        isSourcePercent: dataRender.isSource.percent,
        params: [],
        filesParams: dataRender.filesParams,
      };
    });
    return Promise.all(resultPromises);
  };

  const handleDrop = async (fileList: FileList | RcFile[]) => {
    const currentFiles = stData.dataFiles || [];
    const uniqueFiles = Array.from(fileList).filter(
      (file) => !currentFiles.some((f: any) => f.name === file.name)
    );
    const fileNew = await checkFiles(uniqueFiles) as any;
    const updatedFiles = [...fileNew, ...currentFiles];
    let realFilesParams = {} as any;
    fileNew.map((val: any) => {
      realFilesParams = { ...realFilesParams, ...val.filesParams };
      return true;
    });
    updatedFiles.map((val, index) => {
      const lisDup = updatedFiles.filter(x => x.size === val.size && x.name !== val.name);
      if (lisDup.length > 0) {
        const sr = val.error.filter((er: string) => !er.includes('file khác trong danh sách upload.'));
        val.error = sr;
        val.error.push(`File bị trùng với ${lisDup.length} file khác trong danh sách upload.`);
      }
    })
    onChange({ dataFiles: updatedFiles, filesParams: { ...stData.filesParams, ...realFilesParams } }, null);
    fileInputRef.current!.value = '';
  };


  const handleRemove = (file: any) => {
    const currentFiles = stData.dataFiles || [];
    const updatedFiles = currentFiles.filter((f: any) => f.uid !== file.uid);
    delete stData.filesParams[file.name];
    updatedFiles.map((val: any, index: any) => {
      const lisDup = updatedFiles.filter((x: any) => x.size === val.size && x.name !== val.name);
      if (lisDup.length > 0) {
        const sr = val.error.filter((er: string) => !er.includes('file khác trong danh sách upload.'));
        val.error = sr;
        val.error.push(`File bị trùng với ${lisDup.length} file khác trong danh sách upload.`);
      } else {
        const sr = val.error.filter((er: string) => !er.includes('file khác trong danh sách upload.'));
        val.error = sr;
      }
    })
    onChange({ dataFiles: updatedFiles, filesParams: { ...stData.filesParams } }, null);
  };

  return (
    <div className="upload-page">
      <div className="list-upload-files">
        <input ref={fileInputRef} type="file" multiple className='file-input' onChange={(e) => {
          if (e.target.files) {
            handleDrop(e.target.files);
          }
        }} />
        <div className="ant-upload-drag-icon">
          <svg width="1em" height="1em" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.4987 17.5095H27.4474V40.1635C27.4474 40.4582 27.6885 40.6992 27.9831 40.6992H32.001C32.2956 40.6992 32.5367 40.4582 32.5367 40.1635V17.5095H37.4987C37.9474 17.5095 38.1952 16.9939 37.9206 16.6457L30.4206 7.15013C30.3705 7.0861 30.3065 7.03431 30.2334 6.9987C30.1603 6.96309 30.0801 6.94458 29.9987 6.94458C29.9174 6.94458 29.8372 6.96309 29.7641 6.9987C29.691 7.03431 29.627 7.0861 29.5769 7.15013L22.0769 16.639C21.8023 16.9939 22.0501 17.5095 22.4987 17.5095V17.5095ZM54.5077 38.1546H50.4898C50.1952 38.1546 49.9541 38.3957 49.9541 38.6903V49.0028H10.0434V38.6903C10.0434 38.3957 9.80232 38.1546 9.50767 38.1546H5.48982C5.19517 38.1546 4.9541 38.3957 4.9541 38.6903V51.9492C4.9541 53.1345 5.91169 54.0921 7.09696 54.0921H52.9005C54.0858 54.0921 55.0434 53.1345 55.0434 51.9492V38.6903C55.0434 38.3957 54.8023 38.1546 54.5077 38.1546Z" fill="#1890FF" />
          </svg>
        </div>
        <div className='fz-20-28'>Kéo và thả văn bản vào hoặc <span className="choose-file">Chọn từ máy</span></div>
        <div className="fz-16-500-667085">Hỗ trợ định dạng xls, xlsx, csv</div>
        <div className="note-block">
          <div className="icon-svg">
            <svg width="1em" height="1em" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 16.7139C10.0786 16.7139 10.1426 16.7789 10.1426 16.8574V17.4287C10.1425 17.7447 9.88731 18 9.57129 18H6.14258C5.82669 17.9998 5.57136 17.7446 5.57129 17.4287V16.8574C5.57129 16.779 5.63549 16.7141 5.71387 16.7139H10ZM7.85742 2C11.0912 2.00015 13.7139 4.62358 13.7139 7.85742C13.7138 10.0251 12.536 11.9182 10.7861 12.9307V15C10.7861 15.3161 10.5299 15.5713 10.2139 15.5713H5.5C5.18393 15.5713 4.92871 15.3161 4.92871 15V12.9307C3.17879 11.9182 2.0001 10.0252 2 7.85742C2 4.62349 4.62349 2 7.85742 2ZM7.85742 3.28613C5.33242 3.28613 3.28613 5.33242 3.28613 7.85742C3.28623 9.50902 4.16808 11.0049 5.57324 11.8174L6.21387 12.1895V14.2861H9.5V12.1895L10.1406 11.8174C11.5459 11.0049 12.4286 9.5091 12.4287 7.85742C12.4287 5.33251 10.3823 3.28628 7.85742 3.28613Z" fill="#1890FF" />
            </svg>
          </div>
          <div className="content-note">Để tránh hệ thống kiểm tra trùng và từ chối file import, vui lòng thêm hậu tố ngày tháng import vào tên file (YYYYMMDD) để đảm bảo tính duy nhất <br />Ví dụ: [Hệ thống]_[Tên file]_[Ngày import]</div>
        </div>
      </div>

      <div className="upload-list">
        {stData.dataFiles.map((f: any) => (
          <div className={`file-item ${f.error ? 'error1' : ''}`} key={f.uid}>
            <div className="icon-file">
              <img src={f.icon} alt={f.tail} />
            </div>
            <div className="file-name">
              <div className="name">({mixConvertSize(f.size)}) {f.name}</div>
              {f.error && f.error.length > 0 && (
                f.error.map((err: string, idx: number) => (
                  <div key={idx} className="error-text">- {err}</div>
                ))
              )}
              {f.warnings && (
                <div className="warning-text">- {f.warnings}</div>
              )}

              {f.lsEr.length > 0 && (
                <div className="lser-list">
                  {f.lsEr.map((er: any, idx: number) => (
                    <div key={idx} className="lser-item">
                      - <b>{er.val1}</b> và <b>{er.val2}</b> trùng giá trị <b>{er.pr}</b>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <Tooltip title="Xoá">
              <div
                className='fz-16'
                onClick={() => handleRemove(f)}
              >
                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM10.5844 10.6594L9.55313 10.6547L8 8.80313L6.44844 10.6531L5.41563 10.6578C5.34688 10.6578 5.29063 10.6031 5.29063 10.5328C5.29063 10.5031 5.30156 10.475 5.32031 10.4516L7.35313 8.02969L5.32031 5.60938C5.30143 5.58647 5.29096 5.5578 5.29063 5.52812C5.29063 5.45937 5.34688 5.40312 5.41563 5.40312L6.44844 5.40781L8 7.25938L9.55156 5.40938L10.5828 5.40469C10.6516 5.40469 10.7078 5.45937 10.7078 5.52969C10.7078 5.55937 10.6969 5.5875 10.6781 5.61094L8.64844 8.03125L10.6797 10.4531C10.6984 10.4766 10.7094 10.5047 10.7094 10.5344C10.7094 10.6031 10.6531 10.6594 10.5844 10.6594Z" fill="#98A2B3" />
                </svg>
              </div>
            </Tooltip>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileUploadManager;
